<template>
  <section class="tariff-hero">
    <div class="container">
      <h2 class="tariff-hero__title">Тарифы</h2>
      <p class="tariff-hero__subtitle">
        От бесплатного мини-отчёта до API-интеграций — мы растем с вами.
      </p>
      <div class="tariff-hero__benefits">
        <div class="benefit">
          <div class="circle">
            <img src="@/assets/images/icons/check.svg" alt="check" />
          </div>
          Без скрытых комиссий
        </div>
        <div class="benefit">
          <div class="circle">
            <img src="@/assets/images/icons/check.svg" alt="check" />
          </div>
          Безопасность по умолчанию
        </div>
        <div class="benefit">
          <div class="circle">
            <img src="@/assets/images/icons/check.svg" alt="check" />
          </div>
          Начните бесплатно
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.container {
  max-width: 1200px;
  margin: 0 auto;
}
.tariff-hero {
  background: rgba(245, 247, 250, 1);
  padding: 64px 20px;
  color: rgba(62, 62, 62, 1);
}
.tariff-hero__title {
  font-size: 45px;
  font-weight: 700;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 32px;
  }
}
.tariff-hero__subtitle {
  font-size: 30px;
  color: rgba(62, 62, 62, 1);
  margin-bottom: 30px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
}
.tariff-hero__benefits {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 12px;
}
.benefit {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 22px;

  @media (max-width: 768px) {
    font-size: 18px;
  }
}
.circle {
  background: linear-gradient(180deg, #00c782 0%, #12986a 100%);
  border-radius: 50%;
  box-shadow: 0px 8px 24px 0px rgba(129, 135, 189, 0.15);
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
  }

  img {
    width: 25px;
    height: 20px;
  }
}
</style>
